import Button from '@jetbrains/ring-ui/components/button/button'
import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import List from '@jetbrains/ring-ui/components/list/list'
import Toggle, {Size} from '@jetbrains/ring-ui/components/toggle/toggle'
import type {MouseEventHandler} from 'react'
import {memo, useCallback, useMemo} from 'react'

import {useAppDispatch, useAppSelector} from '../../../../../../../hooks/react-redux'
import PopupMenu from '../../../../../../common/Popup/PopupMenu'
import {setRelativeTimeInBuildlog, setSoftWrapLinesInBuildlog} from '../../../../BuildLog.actions'
import {getRelativeTimeInBuildlog, getSoftWrapLinesInBuildlog} from '../../../../BuildLog.selectors'

import styles from './ViewToggle.css'

const stopPropagation: MouseEventHandler<HTMLElement> = e => {
  e.stopPropagation()
}

function ViewToggle() {
  const dispatch = useAppDispatch()

  const isSoftWrap = useAppSelector(getSoftWrapLinesInBuildlog)
  const isRelativeTime = useAppSelector(getRelativeTimeInBuildlog)

  const onToggleRelativeTime = useCallback(() => {
    dispatch(setRelativeTimeInBuildlog(!isRelativeTime))
  }, [dispatch, isRelativeTime])

  const onToggleSoftWrap = useCallback(() => {
    dispatch(setSoftWrapLinesInBuildlog(!isSoftWrap))
  }, [dispatch, isSoftWrap])

  const renderItem = useCallback(
    (label: string, value: boolean, onChange: () => void) => (
      <div role="presentation" onClick={stopPropagation}>
        <Toggle size={Size.Size16} checked={value} onChange={onChange} />
        <span className={styles.itemLabel}>{label}</span>
      </div>
    ),
    [],
  )

  const items = useMemo(
    () => [
      {
        key: 'ALL_FILES',
        label: 'Soft-wrap lines',
        template: renderItem('Soft-wrap lines', isSoftWrap, onToggleSoftWrap),
        rgItemType: List.ListProps.Type.CUSTOM,
        disabled: true,
      },
      {
        key: 'GRAPH',
        label: 'Time relative to build start',
        template: renderItem('Time relative to build start', isRelativeTime, onToggleRelativeTime),
        rgItemType: List.ListProps.Type.CUSTOM,
        disabled: true,
      },
    ],
    [onToggleSoftWrap, onToggleRelativeTime, renderItem, isSoftWrap, isRelativeTime],
  )

  return (
    <Dropdown anchor={<Button dropdown>{'View '}</Button>}>
      <PopupMenu closeOnSelect data={items} />
    </Dropdown>
  )
}

export default memo(ViewToggle)
